export const CLI_KIT_VERSION = '3.83.3'
